export default __webpack_public_path__ + "static/media/SelectedRadio.e2795b71.svg";